<template>
  <iframe
    class="cancellation-agreement"
    src="https://protocol.xd.cn/logout-agreement.html"
    title="心动账号注销协议"
    frameborder="0"
  ></iframe>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.cancellation-agreement {
  display: block;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 0;
  border: 0;
  background-color: #fff;
}
</style>
